var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2 d-flex justify-content-center align-items-center"},[_vm._t("left-content"),_vm._v(" "),_c('div',{staticClass:"mr-2 text-primary font-weight-bolder text-nowrap"},[_vm._t("default")],2),_vm._v(" "),_c('hr',{staticClass:"w-full",staticStyle:{"border-top":"2px solid #005CC4"}}),_vm._v(" "),_vm._t("right-content")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41362115","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-form/form-sub-title.vue
// module id = nxD6
// module chunks = 23